/* @flow */
import { OrderedMap, Set, fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable';
import type { Action } from 'trustar/utils/redux-types.js';

import {
  STORE_ANALYSIS,

  FETCH_ANALYSIS,
  FETCH_ANALYSIS_SUCCESS,
  FETCH_ANALYSIS_FAILURE,

  FETCH_ANALYSES_SUCCESS,
  FETCH_SHARED_ANALYSES_SUCCESS,
  SAVE_ANALYSIS_SUCCESS,
  UPDATE_ANALYSIS_SUCCESS,
  SHARE_ANALYSIS_SUCCESS,
  DELETE_ANALYSIS_SUCCESS,
  SET_DISPLAY_OPTIONS,
} from './action-types.js';

const listToOrderedMap = (list) =>
  fromJS(list)
    .filter(x => x.get('guid')) // Filter out anything without a guid
    .toOrderedMap()
    .mapKeys((k, v) => v.get('guid'));

const saved = (state = OrderedMap(), action) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_ANALYSES_SUCCESS:
    return listToOrderedMap(payload); // NOTE: Do we want to completely overwrite state here?
  case SAVE_ANALYSIS_SUCCESS:
  case UPDATE_ANALYSIS_SUCCESS:
    return state.set(payload.get('guid'), payload);
  case DELETE_ANALYSIS_SUCCESS:
    return state.delete(payload);
  case SHARE_ANALYSIS_SUCCESS:
    return state.setIn([payload.guid, 'sharedWith'], payload.sharedWith);
  default:
    return state;
  }
};

const shared = (state = OrderedMap(), action) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_SHARED_ANALYSES_SUCCESS:
    return listToOrderedMap(payload); // NOTE: Do we want to completely overwrite state here?
  case STORE_ANALYSIS:
    return state.set(payload.get('guid'), payload);
  default:
    return state;
  }
};

const filters = (state = Set(['saved', 'shared']), action: Action<any>) => {
  const { type, payload } = action;

  switch (type) {
  case SET_DISPLAY_OPTIONS:
    return Set(payload);
  default:
    return state;
  }
};

const loading = (state = false, action: Action<any>) => {
  const { type } = action;

  switch(type) {
  case FETCH_ANALYSIS:
    return true;
  case FETCH_ANALYSIS_SUCCESS:
  case FETCH_ANALYSIS_FAILURE:
    return false;
  default:
    return state;
  }
};

export const analyses = combineReducers({
  saved,
  shared,
});

export const analysesMeta = combineReducers({
  filters,
  loading,
});



// WEBPACK FOOTER //
// ./src/app/modules/analysis/stores.js